import FqApi from '@/services/fq-api'
import ProtoBuf from 'protobufjs'
import ProtoBufApi from '@/services/protobuf-api'

const baseUrl = '/whatsapp'

export default {
  async getEntitySummaries(filter) {
    const serialised = this.serialiseMessageFilter(filter)
    const url = `${baseUrl}/list/${serialised}`
    const result = await FqApi.get(url)
    return result.data
  },
  serialiseMessageFilter(filter) {
    const entityProto = require('../assets/proto/sms/SmsMessageFilter.proto')
    const filterMessage = entityProto.SmsMessageFilter.SmsMessageFilterModel
    const buffer = filterMessage.encode(filter).finish()
    const b64encoded = ProtoBuf.util.base64.encode(buffer, 0, buffer.length)
    return b64encoded
  },
  async getSmsMessageDropdownProto(filter) {
    const serialised = encodeURIComponent(this.serialiseSmsMessageDropdownFilter(filter))
    const result = await ProtoBufApi(`/sms/protobuf/sendsms/listcombo?filter=${serialised}`)
    const proto = require('../assets/proto/sms/SmsMessageDropdown.proto')
    const message = proto.SmsMessageDropdown.SmsMessageDropdownModel
    const entity = message.decode(new Uint8Array(result.data))
    return entity.assets
  },
  serialiseSmsMessageDropdownFilter(filter) {
    const entityProto = require('../assets/proto/sms/SmsMessageDropdownFilter.proto')
    const filterMessage = entityProto.SmsMessageDropdownFilter.SmsMessageDropdownFilterModel
    const buffer = filterMessage.encode(filter).finish()
    const b64encoded = ProtoBuf.util.base64.encode(buffer, 0, buffer.length)
    return b64encoded
  },
  async sendWhatsApp(info) {
    const result = await FqApi.post(`${baseUrl}/send`, info)
    return result.data
  },
  postEntity(entity) {
    return FqApi.post(`${baseUrl}/new`, entity)
  },
  putEntity(entity) {
    return FqApi.put(`${baseUrl}/${entity.id}`, entity)
  },
  deleteEntity(id) {
    return FqApi.delete(`${baseUrl}/${id}`)
  },
  async getMessages(quoteId) {
    const result = await FqApi.get(`${baseUrl}/messages/${quoteId}`)
    return result.data
  },
  async getUnreadCount(quoteId) {
    const result = await FqApi.get(`${baseUrl}/unreadcount/${quoteId}`)
    return result.data
  },
  async setMessagesAsRead(quoteId) {
    const result = await FqApi.post(`${baseUrl}/setasread/${quoteId}`)
    return result.data
  },
  async getCompanyExternalSetting(companyId) {
    const result = await FqApi.post(`${baseUrl}/getcompanyexternalsettting`)
    return result.data
  }

}
